const round6 = (value) => Math.round(value * 1000000) / 1000000;

export const billsByPeriod = ({
  groupedAccounts,
  quote = null,
  totalUsd,
  amountConverted,
  fromBalance = false,
  incomeCreditByPeriod = {},
  prospectiveDiscountByPeriod = {},
  category = null,
}) => {
  const total = Number(totalUsd) || 0;
  const converted = Number(amountConverted) || 0;
  let remainingAmount = total;
  let remainingConverted = converted;
  const bills = [];

  for (const periodId in groupedAccounts) {
    const accounts = groupedAccounts[periodId];
    if (!Array.isArray(accounts)) continue;

    const quotedPeriod =
      quote?.periods?.find((p) => String(p.period_id) === String(periodId)) || null;
    const rawPeriodTotal = accounts.reduce((acc, cuenta) => acc + Number(cuenta.amount || 0), 0);
    const paidInPeriod = accounts.reduce((acc, cuenta) => acc + Number(cuenta.total_paid || 0), 0);
    const credit = incomeCreditByPeriod[periodId] || 0;
    const discount = prospectiveDiscountByPeriod[periodId] || 0;
    const isCategoryPeriod = Boolean(category) && String(category.periodId) === String(periodId);

    const chargeableNow = quotedPeriod
      ? Number(quotedPeriod.payable)
      : isCategoryPeriod
      ? Number(category.payable)
      : Math.max(rawPeriodTotal - paidInPeriod - credit - discount, 0);

    const billTotal = quotedPeriod
      ? Number(quotedPeriod.total_amount)
      : isCategoryPeriod
      ? Number(category.total)
      : Math.max(rawPeriodTotal - credit - discount, 0);

    const amount = quotedPeriod
      ? Number(quotedPeriod.amount)
      : Math.min(chargeableNow, remainingAmount);
    remainingAmount -= amount;

    const amountConvertedForPeriod =
      quotedPeriod && quotedPeriod.amount_converted !== null && quotedPeriod.amount_converted !== undefined
        ? Number(quotedPeriod.amount_converted)
        : remainingAmount <= 0 || total <= 0
        ? remainingConverted
        : Math.min(Math.round(converted * (amount / total) * 100) / 100, remainingConverted);
    remainingConverted -= amountConvertedForPeriod;

    bills.push({
      periodId,
      accounts,
      amount,
      amountConverted: amountConvertedForPeriod,
      total: billTotal,
    });

    if (remainingAmount <= 0) break;
  }

  const leftover = round6(total - bills.reduce((acc, bill) => acc + bill.amount, 0));
  const leftoverConverted = Math.max(
    round6(converted - bills.reduce((acc, bill) => acc + bill.amountConverted, 0)),
    0
  );

  if (bills.length > 0 && leftover > 0.000001 && !fromBalance) {
    const lastBill = bills[bills.length - 1];
    lastBill.amount = round6(lastBill.amount + leftover);
    lastBill.amountConverted = round6(lastBill.amountConverted + leftoverConverted);
  }

  return bills;
};
